import { SiteHeader } from '../components/SiteHeader';
import { useDocumentMeta } from '../lib/useDocumentMeta';
import { asset } from '../lib/asset';

interface Project {
  logo: string;
  alt: string;
  title: string;
  desc: string;
  href: string;
  cta: string;
  ctaHidden?: string;
}

const PROJECTS: Project[] = [
  {
    logo: 'assets/images/peer-logo.png',
    alt: 'PEERClinic for Back Pain and Spine Surgery',
    title: 'PEERClinic',
    desc: 'Orthopedic Surgeon in Northern Virginia',
    href: 'https://peerclinic.com/',
    cta: 'Visit PEERClinic',
  },
  {
    logo: 'assets/images/backpainlogo-withtext.svg',
    alt: 'Back Pain Tracker Logo',
    title: 'Back Pain Tracker',
    desc: 'An app for back pain focused on Patient Reported Outcomes.',
    href: 'https://app.peerclinic.com/',
    cta: 'Visit Back Pain Tracker',
  },
  {
    logo: 'assets/images/GroovinGourmets.png',
    alt: 'Groovin Gourmets',
    title: "Groovin' Gourmets & Trolley House Refreshments",
    desc: 'Richmond, VA Catering Company: Weddings, Box Lunches, Corporate Catering, Movie Sets, and Special Events Catering in Virginia',
    href: 'https://groovingourmets.com/',
    cta: 'Visit',
    ctaHidden: " Groovin' Gourmets",
  },
  {
    logo: 'assets/images/peersrva-logo.png',
    alt: 'PEERS RVA',
    title: 'PEERS RVA',
    desc: 'Evidence Based Social Skills Classes for Neurodiverse and Neurotypical Teens and Young Adults.',
    href: 'https://peersrva.com/',
    cta: 'Visit',
    ctaHidden: ' PEERS RVA',
  },
];

export function Portfolio() {
  useDocumentMeta({ title: 'Portfolio | Tyler Wrenn' });

  return (
    <main>
      <SiteHeader />

      <div className="portfolio">
        <div className="container">
          <h2 className="portfolio__heading">My Portfolio</h2>

          <div className="portfolio__grid">
            {PROJECTS.map((project) => (
              <article className="portfolio-card" key={project.title}>
                <div className="portfolio-card__media">
                  <img className="portfolio-card__logo" src={asset(project.logo)} alt={project.alt} />
                </div>
                <h3 className="portfolio-card__title">{project.title}</h3>
                <p className="portfolio-card__desc">{project.desc}</p>
                <a
                  className="portfolio-card__cta"
                  href={project.href}
                  rel="noopener noreferrer"
                  role="button"
                  target="_blank"
                >
                  {project.cta}
                  {project.ctaHidden && <span className="visually-hidden">{project.ctaHidden}</span>}
                </a>
              </article>
            ))}
          </div>

          <p className="portfolio__outro">&ndash; More projects in the works &ndash;</p>
          <hr className="border-footer" />
          <footer className="portfolio__footer">
            <p className="small">
              Designed by Tyler Wrenn
              <br />
              All copyrights are for their respected owners.
            </p>
          </footer>
        </div>
      </div>
    </main>
  );
}
